import { Component } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import Template from "./template.vue";
import { FrmLogin } from "@/store/modules/auth/types";
import FormsMixin from "@/mixins/FormsMixin";

@Component({
  mixins: [Template],
})
export default class Login extends FormsMixin {
  @Action("login", { namespace: "auth" }) login!: Function;
  @Action("checkPassword", { namespace: "auth" }) checkPassword!: Function;
  @Action("resetPassword", { namespace: "auth" }) resetPassword!: Function;
  @Action("updateKey") updateKey!: Function;
  @Action("obtenerCliente", { namespace: "SeleccionCliente" }) obtenerCliente!: Function;
  @State('isMobile') isMobile!: boolean;

  public resetpassword = false;
  public valid = false;
  public frmLogin: Partial<FrmLogin> = {
    usuario: "",
    password: "",
    passwordRep: ""
  };

  mounted() {
    // if (localStorage.getItem('userLogged') != null) {
    //   localStorage.removeItem('userLogged');
    // }
    window.scrollTo(0, 0);
  }

  async submit(): Promise<void> {
    const form: any = this.$refs.form;
    if (form.validate()) {
      this.$root.$emit("loading", true);
      try {

        if (this.resetpassword) {

          if (this.frmLogin.password === this.frmLogin.passwordRep) {
            await this.resetPassword({ user: this.frmLogin.usuario, password: this.frmLogin.password });
            this.frmLogin.password = "";
            this.frmLogin.passwordRep = "";
            this.resetpassword = false;
            this.$toast.success("Contraseña actualizada");
            this.$root.$emit("loading", false);
          } else 
          {
            this.$root.$emit("loading", false);
            this.$toast.error("Las contraseñas no coinciden.");
          }

        } else {
          //comprobar contraseña vacía
          this.resetpassword = await this.checkPassword({user: this.frmLogin.usuario});

          if (!this.resetpassword) {
            const UsuarioLogeado = await this.login(this.frmLogin);
            this.$root.$emit("loading", false);
            this.updateKey();
            localStorage.setItem("userLogged", JSON.stringify(UsuarioLogeado))
            if (UsuarioLogeado.esCliente == false){
              this.$router.push({ name: "SeleccionCliente" });
            } else {
              const cliente = await this.obtenerCliente({ codcli: UsuarioLogeado.id });
              localStorage.setItem("CliePedido", JSON.stringify(cliente))  
              this.$router.push({ name: "venta" });
            }
          } else { //RESET PASSWORD
            this.frmLogin.password = "";
            this.frmLogin.passwordRep = "";
            this.$root.$emit("loading", false);

          }
        }

        
      } catch (error) {
        this.$root.$emit("loading", false);
      }
    }
  }
}
